import colors from '../../scss/colors';
import sectionOneImage from '../../Assets/images/home/imageSectionOne.webp';
import sectionTwoImage from '../../Assets/images/home/imageSectionTwo.webp';
import sectionThreeImage from '../../Assets/images/home/imageSectionThree.webp';

export const contentSectionOne = (t) => [
  {
    id: 1,
    title: t('landingPages.contentSectionOne.title'),
    image: sectionOneImage,
    cardColor: colors.LIGHTER_BLUE,
    isDark: false,
    imagePosition: 'left',
    imageBackdrop: false,
    content: [
      {
        id: 1,
        title: t('landingPages.contentSectionOne.contentOneTitle'),
        description: t('landingPages.contentSectionOne.contentOneDescription')
      },
      {
        id: 2,
        title: t('landingPages.contentSectionOne.contentTwoTitle'),
        description: t('landingPages.contentSectionOne.contentTwoDescription')
      },
      {
        id: 3,
        title: t('landingPages.contentSectionOne.contentThreeTitle'),
        description: t('landingPages.contentSectionOne.contentThreeDescription')
      }
    ]
  },
  {
    id: 2,
    title: t('landingPages.contentSectionTwo.title'),
    image: sectionTwoImage,
    cardColor: colors.LIGHT_BLUE,
    isDark: true,
    imagePosition: 'right',
    imageBackdrop: false,
    content: [
      {
        id: 2,
        title: t('landingPages.contentSectionTwo.contentTwoTitle'),
        description: t('landingPages.contentSectionTwo.contentTwoDescription')
      },
      {
        id: 3,
        title: t('landingPages.contentSectionTwo.contentThreeTitle'),
        description: t('landingPages.contentSectionTwo.contentThreeDescription')
      }
    ]
  }
];

export const contentSectionTwo = (t) => [
  {
    id: 1,
    title: t('landingPages.contentSectionThree.title'),
    image: sectionThreeImage,
    cardColor: colors.DARK_BLUE,
    isDark: true,
    imagePosition: 'left',
    imageBackdrop: true,
    content: [
      {
        id: 1,
        title: t('landingPages.contentSectionThree.contentOneTitle'),
        description: t('landingPages.contentSectionThree.contentOneDescription')
      },
      {
        id: 2,
        title: t('landingPages.contentSectionThree.contentTwoTitle'),
        description: t('landingPages.contentSectionThree.contentTwoDescription')
      },
      {
        id: 3,
        title: t('landingPages.contentSectionThree.contentThreeTitle'),
        description: t('landingPages.contentSectionThree.contentThreeDescription')
      }
    ]
  }
];

export const faqContent = (t) => {
  return {
    accounts: [
      {
        id: 1,
        question: t('landingPages.faq.contentQuestion1'),
        answer: t('landingPages.faq.contentAnswer1')
      },
      {
        id: 2,
        question: t('landingPages.faq.contentQuestion2'),
        answer: t('landingPages.faq.contentAnswer2')
      },
      {
        id: 3,
        question: t('landingPages.faq.contentQuestion3'),
        answer: t('landingPages.faq.contentAnswer3')
      },
      {
        id: 5,
        question: t('landingPages.faq.contentQuestion4'),
        answer: t('landingPages.faq.contentAnswer4')
      },
      {
        id: 6,
        question: t('landingPages.faq.contentQuestion5'),
        answer: t('landingPages.faq.contentAnswer5')
      }
    ],
    jobs: [
      {
        id: 1,
        question: t('landingPages.faq.contentQuestion6'),
        answer: t('landingPages.faq.contentAnswer6')
      },
      {
        id: 2,
        question: t('landingPages.faq.contentQuestion7'),
        answer: t('landingPages.faq.contentAnswer7')
      },
      {
        id: 3,
        question: t('landingPages.faq.contentQuestion8'),
        answer: t('landingPages.faq.contentAnswer8')
      }
    ],
    others: [
      {
        id: 1,
        question: t('landingPages.faq.contentQuestion9'),
        answer: t('landingPages.faq.contentAnswer9')
      },
      {
        id: 2,
        question: t('landingPages.faq.contentQuestion10'),
        answer: t('landingPages.faq.contentAnswer10')
      },
      {
        id: 3,
        question: t('landingPages.faq.contentQuestion11'),
        answer: t('landingPages.faq.contentAnswer11')
      },
      {
        id: 4,
        question: t('landingPages.faq.contentQuestion12'),
        answer: t('landingPages.faq.contentAnswer12')
      },
      {
        id: 5,
        question: t('landingPages.faq.contentQuestion13'),
        answer: t('landingPages.faq.contentAnswer13')
      }
    ]
  };
};
